<template>
  <div class="rounded-md inline-flex media-controls" role="group">
    <button
      type="button"
      @click="prevTrack"
      class="button button-anim rounded-tl-3xl rounded-bl-3xl button-hollow media-button  text-white"
    >
      <font-awesome-icon icon="fa-solid fa-backward" />
    </button>
    <button
      type="button"
      @click="dynamicTogglePlayer"
      class="button media-button button-anim button-hollow text-green"
      :class="{ 'is-active': isPlaying }"
    >
      <font-awesome-icon icon="fa-solid fa-pause" v-if="isPlaying" />
      <font-awesome-icon icon="fa-solid fa-play" v-else />

    </button>
    <button
      type="button"
      @click="nextTrack"
      class="button media-button button-anim rounded-tr-3xl rounded-br-3xl button-hollow  text-white"
    >
      <font-awesome-icon icon="fa-solid fa-forward text-white" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useMedia } from '@/stores/media'

const player = useMedia()
const { isPlaying, playerState } = storeToRefs(player)

const props = defineProps<{
  trackID: number
}>()

const nextTrack = () => {
  player.next()
}

const prevTrack = () => {
  player.prev()
}

const dynamicTogglePlayer = () => {
  if (!player.isVisible) {
    player.setVisibility(true)
  }
  if (!playerState.value) {
    player.playTrack(props.trackID)
  } else {
    player.togglePlay()
  }
}
</script>
